import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "underscore";

const SummaryRow = ({ summary, prefixIcon, border, className, event, setSHowDetails }) => {
  const getEntries = (data) => {
    if (!data) return [];

    if (typeof data === 'object' && !Array.isArray(data)) {
      return Object.entries(_.pick(data, (val) => val > 0)).map(([status, count]) => ({
        status,
        count
      }));
    }

    if (Array.isArray(data)) {
      return data
        .filter(item => item && (item.project_status_count > 0 || item.user_count > 0 || item.project_status_count !== null))
        .map(item => {
          if (item.project_status_name !== null && item.project_status_name !== undefined) {
            return {
              status: item.project_status_name,
              count: item.project_status_count
            };
          }
          if (item.user_count !== null && item.user_count !== undefined) {
            return {
              status: item?.category_name || "Other",
              count: item.user_count,
              category_id: item?.category_id
            };
          }
          return null;
        })
        .filter(item => item && item.count > 0);
    }

    return [];
  };

  const entries = getEntries(summary);

  if (entries.length === 0) return null;

  return (
    <>
      <div className={`d-flex gap-1 inner-text align-items-center `}>
        <FontAwesomeIcon icon={prefixIcon} />
        {entries.map((entry, index) => (
          <div key={`${entry.status}-${index}`} className={className}>
            <span className={`px-1 ${index !== 0 && border ? "border-start" : "c-pointer"} `} onClick={() => event ? setSHowDetails({ show: true, data: entry }) : {}}>
              <span className="text-capitalize">{entry.status?.replaceAll('_', ' ')}: {entry.count}</span>
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default SummaryRow;
